// @generated by protoc-gen-es-ns v0.0.0 with parameter "target=ts"
// @generated from file web/public/shopping.proto (package web.public, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { AutoRenew, SubscriptionPlan, UserSubscription, UserSubscriptionInvoice } from "./subscription_pb.js";
import { Error } from "./error_pb.js";
import { CreditLineAgreement, PaymentSchedule } from "./credit_line_pb.js";
import { Image as Image$1 } from "./image_pb.js";
import { Review } from "./review_pb.js";
import { AutoPay } from "./auto_pay_pb.js";
import { PaymentOption } from "./payment_methods_pb.js";

/**
 * @generated from message web.public.PreviewChangeSubscriptionPlanRequest
 */
export class PreviewChangeSubscriptionPlanRequest extends Message<PreviewChangeSubscriptionPlanRequest> {
  /**
   * @generated from field: web.public.PreviewChangeSubscriptionPlanRequest.Plan plan = 1 [deprecated = true];
   * @deprecated
   */
  plan = PreviewChangeSubscriptionPlanRequest.Plan.UNKNOWN;

  /**
   * @generated from field: web.public.SubscriptionPlan subscription_plan = 2;
   */
  subscriptionPlan = SubscriptionPlan.BASIC;

  constructor(data?: PartialMessage<PreviewChangeSubscriptionPlanRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.PreviewChangeSubscriptionPlanRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan", kind: "enum", T: proto3.getEnumType(PreviewChangeSubscriptionPlanRequest.Plan) },
    { no: 2, name: "subscription_plan", kind: "enum", T: proto3.getEnumType(SubscriptionPlan) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PreviewChangeSubscriptionPlanRequest {
    return new PreviewChangeSubscriptionPlanRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PreviewChangeSubscriptionPlanRequest {
    return new PreviewChangeSubscriptionPlanRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PreviewChangeSubscriptionPlanRequest {
    return new PreviewChangeSubscriptionPlanRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PreviewChangeSubscriptionPlanRequest | PlainMessage<PreviewChangeSubscriptionPlanRequest> | undefined, b: PreviewChangeSubscriptionPlanRequest | PlainMessage<PreviewChangeSubscriptionPlanRequest> | undefined): boolean {
    return proto3.util.equals(PreviewChangeSubscriptionPlanRequest, a, b);
  }

  static _enums: {
    Plan: typeof PreviewChangeSubscriptionPlanRequest.Plan,
  };
}

export namespace PreviewChangeSubscriptionPlanRequest {
  /**
   * @generated from enum web.public.PreviewChangeSubscriptionPlanRequest.Plan
   */
  export enum Plan {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: BASIC = 1;
     */
    BASIC = 1,

    /**
     * @generated from enum value: PREMIUM = 2;
     */
    PREMIUM = 2,

    /**
     * @generated from enum value: ULTIMATE = 3;
     */
    ULTIMATE = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(PreviewChangeSubscriptionPlanRequest.Plan)
  proto3.util.setEnumType(PreviewChangeSubscriptionPlanRequest.Plan, "web.public.PreviewChangeSubscriptionPlanRequest.Plan", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "BASIC" },
    { no: 2, name: "PREMIUM" },
    { no: 3, name: "ULTIMATE" },
  ]);
}

/**
 * @generated from message web.public.PreviewChangeSubscriptionPlanResponse
 */
export class PreviewChangeSubscriptionPlanResponse extends Message<PreviewChangeSubscriptionPlanResponse> {
  /**
   * @generated from field: web.public.PreviewChangeSubscriptionPlanResponse.Status status = 1;
   */
  status = PreviewChangeSubscriptionPlanResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: bool allow_downgrade = 3;
   */
  allowDowngrade = false;

  /**
   * @generated from field: bool allow_upgrade = 4;
   */
  allowUpgrade = false;

  /**
   * @generated from field: web.public.Product product = 5;
   */
  product?: Product;

  /**
   * @generated from field: web.public.PaymentSchedule payment_schedule = 6;
   */
  paymentSchedule?: PaymentSchedule;

  /**
   * @generated from field: web.public.PreviewChangeSubscriptionPlanResponse.GatingMetadata gating_metadata = 7;
   */
  gatingMetadata?: PreviewChangeSubscriptionPlanResponse.GatingMetadata;

  constructor(data?: PartialMessage<PreviewChangeSubscriptionPlanResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.PreviewChangeSubscriptionPlanResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(PreviewChangeSubscriptionPlanResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "allow_downgrade", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "allow_upgrade", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "product", kind: "message", T: Product },
    { no: 6, name: "payment_schedule", kind: "message", T: PaymentSchedule },
    { no: 7, name: "gating_metadata", kind: "message", T: PreviewChangeSubscriptionPlanResponse.GatingMetadata },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PreviewChangeSubscriptionPlanResponse {
    return new PreviewChangeSubscriptionPlanResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PreviewChangeSubscriptionPlanResponse {
    return new PreviewChangeSubscriptionPlanResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PreviewChangeSubscriptionPlanResponse {
    return new PreviewChangeSubscriptionPlanResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PreviewChangeSubscriptionPlanResponse | PlainMessage<PreviewChangeSubscriptionPlanResponse> | undefined, b: PreviewChangeSubscriptionPlanResponse | PlainMessage<PreviewChangeSubscriptionPlanResponse> | undefined): boolean {
    return proto3.util.equals(PreviewChangeSubscriptionPlanResponse, a, b);
  }

  static _enums: {
    Status: typeof PreviewChangeSubscriptionPlanResponse.Status,
  };
}

export namespace PreviewChangeSubscriptionPlanResponse {
  /**
   * @generated from enum web.public.PreviewChangeSubscriptionPlanResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(PreviewChangeSubscriptionPlanResponse.Status)
  proto3.util.setEnumType(PreviewChangeSubscriptionPlanResponse.Status, "web.public.PreviewChangeSubscriptionPlanResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

export namespace PreviewChangeSubscriptionPlanResponse {
  /**
   * @generated from message web.public.PreviewChangeSubscriptionPlanResponse.GatingMetadata
   */
  export class GatingMetadata extends Message<PreviewChangeSubscriptionPlanResponse.GatingMetadata> {
    /**
     * @generated from field: string title = 1;
     */
    title = "";

    /**
     * @generated from field: string description = 2;
     */
    description = "";

    /**
     * @generated from field: web.public.PreviewChangeSubscriptionPlanResponse.GatingMetadata.Status gating_status = 3;
     */
    gatingStatus = PreviewChangeSubscriptionPlanResponse.GatingMetadata.Status.UNKNOWN;

    constructor(data?: PartialMessage<PreviewChangeSubscriptionPlanResponse.GatingMetadata>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.PreviewChangeSubscriptionPlanResponse.GatingMetadata";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 3, name: "gating_status", kind: "enum", T: proto3.getEnumType(PreviewChangeSubscriptionPlanResponse.GatingMetadata.Status) },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PreviewChangeSubscriptionPlanResponse.GatingMetadata {
      return new PreviewChangeSubscriptionPlanResponse.GatingMetadata().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PreviewChangeSubscriptionPlanResponse.GatingMetadata {
      return new PreviewChangeSubscriptionPlanResponse.GatingMetadata().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PreviewChangeSubscriptionPlanResponse.GatingMetadata {
      return new PreviewChangeSubscriptionPlanResponse.GatingMetadata().fromJsonString(jsonString, options);
    }

    static equals(a: PreviewChangeSubscriptionPlanResponse.GatingMetadata | PlainMessage<PreviewChangeSubscriptionPlanResponse.GatingMetadata> | undefined, b: PreviewChangeSubscriptionPlanResponse.GatingMetadata | PlainMessage<PreviewChangeSubscriptionPlanResponse.GatingMetadata> | undefined): boolean {
      return proto3.util.equals(PreviewChangeSubscriptionPlanResponse.GatingMetadata, a, b);
    }

    static _enums: {
      Status: typeof PreviewChangeSubscriptionPlanResponse.GatingMetadata.Status,
    };
  }
}

export namespace PreviewChangeSubscriptionPlanResponse.GatingMetadata {
  /**
   * @generated from enum web.public.PreviewChangeSubscriptionPlanResponse.GatingMetadata.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: COOLDOWN = 1;
     */
    COOLDOWN = 1,

    /**
     * @generated from enum value: OVERDUE = 2;
     */
    OVERDUE = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(PreviewChangeSubscriptionPlanResponse.GatingMetadata.Status)
  proto3.util.setEnumType(PreviewChangeSubscriptionPlanResponse.GatingMetadata.Status, "web.public.PreviewChangeSubscriptionPlanResponse.GatingMetadata.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "COOLDOWN" },
    { no: 2, name: "OVERDUE" },
  ]);
}

/**
 * @generated from message web.public.ChangeSubscriptionPlanRequest
 */
export class ChangeSubscriptionPlanRequest extends Message<ChangeSubscriptionPlanRequest> {
  /**
   * @generated from field: web.public.ChangeSubscriptionPlanRequest.Plan plan = 1 [deprecated = true];
   * @deprecated
   */
  plan = ChangeSubscriptionPlanRequest.Plan.UNKNOWN;

  /**
   * @generated from field: web.public.SubscriptionPlan subscription_plan = 2;
   */
  subscriptionPlan = SubscriptionPlan.BASIC;

  /**
   * @generated from field: string source = 3;
   */
  source = "";

  constructor(data?: PartialMessage<ChangeSubscriptionPlanRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ChangeSubscriptionPlanRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan", kind: "enum", T: proto3.getEnumType(ChangeSubscriptionPlanRequest.Plan) },
    { no: 2, name: "subscription_plan", kind: "enum", T: proto3.getEnumType(SubscriptionPlan) },
    { no: 3, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeSubscriptionPlanRequest {
    return new ChangeSubscriptionPlanRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeSubscriptionPlanRequest {
    return new ChangeSubscriptionPlanRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeSubscriptionPlanRequest {
    return new ChangeSubscriptionPlanRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeSubscriptionPlanRequest | PlainMessage<ChangeSubscriptionPlanRequest> | undefined, b: ChangeSubscriptionPlanRequest | PlainMessage<ChangeSubscriptionPlanRequest> | undefined): boolean {
    return proto3.util.equals(ChangeSubscriptionPlanRequest, a, b);
  }

  static _enums: {
    Plan: typeof ChangeSubscriptionPlanRequest.Plan,
  };
}

export namespace ChangeSubscriptionPlanRequest {
  /**
   * @generated from enum web.public.ChangeSubscriptionPlanRequest.Plan
   */
  export enum Plan {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: BASIC = 1;
     */
    BASIC = 1,

    /**
     * @generated from enum value: PREMIUM = 2;
     */
    PREMIUM = 2,

    /**
     * @generated from enum value: ULTIMATE = 3;
     */
    ULTIMATE = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ChangeSubscriptionPlanRequest.Plan)
  proto3.util.setEnumType(ChangeSubscriptionPlanRequest.Plan, "web.public.ChangeSubscriptionPlanRequest.Plan", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "BASIC" },
    { no: 2, name: "PREMIUM" },
    { no: 3, name: "ULTIMATE" },
  ]);
}

/**
 * @generated from message web.public.ChangeSubscriptionPlanResponse
 */
export class ChangeSubscriptionPlanResponse extends Message<ChangeSubscriptionPlanResponse> {
  /**
   * @generated from field: web.public.ChangeSubscriptionPlanResponse.Status status = 1;
   */
  status = ChangeSubscriptionPlanResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  constructor(data?: PartialMessage<ChangeSubscriptionPlanResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ChangeSubscriptionPlanResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ChangeSubscriptionPlanResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeSubscriptionPlanResponse {
    return new ChangeSubscriptionPlanResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeSubscriptionPlanResponse {
    return new ChangeSubscriptionPlanResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeSubscriptionPlanResponse {
    return new ChangeSubscriptionPlanResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeSubscriptionPlanResponse | PlainMessage<ChangeSubscriptionPlanResponse> | undefined, b: ChangeSubscriptionPlanResponse | PlainMessage<ChangeSubscriptionPlanResponse> | undefined): boolean {
    return proto3.util.equals(ChangeSubscriptionPlanResponse, a, b);
  }

  static _enums: {
    Status: typeof ChangeSubscriptionPlanResponse.Status,
  };
}

export namespace ChangeSubscriptionPlanResponse {
  /**
   * @generated from enum web.public.ChangeSubscriptionPlanResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ChangeSubscriptionPlanResponse.Status)
  proto3.util.setEnumType(ChangeSubscriptionPlanResponse.Status, "web.public.ChangeSubscriptionPlanResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.Product
 */
export class Product extends Message<Product> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  /**
   * @generated from field: string headliner = 2;
   */
  headliner = "";

  /**
   * @generated from field: string title = 3;
   */
  title = "";

  /**
   * @generated from field: string description = 4;
   */
  description = "";

  /**
   * @generated from field: uint32 price_cents = 5;
   */
  priceCents = 0;

  /**
   * @generated from field: repeated web.public.Product.Image images = 6;
   */
  images: Product.Image[] = [];

  /**
   * @generated from field: web.public.Product.Type type = 7;
   */
  type = Product.Type.UNKNOWN;

  /**
   * @generated from field: repeated web.public.Product.Metadata metadata = 8;
   */
  metadata: Product.Metadata[] = [];

  /**
   * @generated from field: repeated string tags = 9;
   */
  tags: string[] = [];

  /**
   * @generated from field: uint32 repayment_term = 10;
   */
  repaymentTerm = 0;

  /**
   * @generated from field: uint32 monthly_payment_cents = 11;
   */
  monthlyPaymentCents = 0;

  /**
   * @generated from field: uint32 original_price_cents = 12;
   */
  originalPriceCents = 0;

  /**
   * @generated from field: string promo_text = 13;
   */
  promoText = "";

  /**
   * @generated from field: uint32 lease_duration_seconds = 14;
   */
  leaseDurationSeconds = 0;

  /**
   * @generated from field: uint32 subscription_duration_months = 15;
   */
  subscriptionDurationMonths = 0;

  /**
   * @generated from field: web.public.SubscriptionPlan plan = 16;
   */
  plan = SubscriptionPlan.BASIC;

  /**
   * @generated from field: web.public.CreditLineAgreement credit_line_agreement = 17;
   */
  creditLineAgreement?: CreditLineAgreement;

  /**
   * @generated from field: uint32 pay_in_full_price_cents = 18;
   */
  payInFullPriceCents = 0;

  constructor(data?: PartialMessage<Product>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.Product";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "headliner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "price_cents", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 6, name: "images", kind: "message", T: Product.Image, repeated: true },
    { no: 7, name: "type", kind: "enum", T: proto3.getEnumType(Product.Type) },
    { no: 8, name: "metadata", kind: "message", T: Product.Metadata, repeated: true },
    { no: 9, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "repayment_term", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 11, name: "monthly_payment_cents", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 12, name: "original_price_cents", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 13, name: "promo_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "lease_duration_seconds", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 15, name: "subscription_duration_months", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 16, name: "plan", kind: "enum", T: proto3.getEnumType(SubscriptionPlan) },
    { no: 17, name: "credit_line_agreement", kind: "message", T: CreditLineAgreement },
    { no: 18, name: "pay_in_full_price_cents", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Product {
    return new Product().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Product {
    return new Product().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Product {
    return new Product().fromJsonString(jsonString, options);
  }

  static equals(a: Product | PlainMessage<Product> | undefined, b: Product | PlainMessage<Product> | undefined): boolean {
    return proto3.util.equals(Product, a, b);
  }

  static _enums: {
    Type: typeof Product.Type,
  };
}

export namespace Product {
  /**
   * @generated from enum web.public.Product.Type
   */
  export enum Type {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: BOOK = 1;
     */
    BOOK = 1,

    /**
     * @generated from enum value: SUBSCRIPTION = 2;
     */
    SUBSCRIPTION = 2,

    /**
     * @generated from enum value: COURSE = 3;
     */
    COURSE = 3,

    /**
     * @generated from enum value: BANZAI_GOAL_PACKAGE = 4;
     */
    BANZAI_GOAL_PACKAGE = 4,

    /**
     * @generated from enum value: BOOKS_BUNDLE = 5;
     */
    BOOKS_BUNDLE = 5,
  }
  // Retrieve enum metadata with: proto3.getEnumType(Product.Type)
  proto3.util.setEnumType(Product.Type, "web.public.Product.Type", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "BOOK" },
    { no: 2, name: "SUBSCRIPTION" },
    { no: 3, name: "COURSE" },
    { no: 4, name: "BANZAI_GOAL_PACKAGE" },
    { no: 5, name: "BOOKS_BUNDLE" },
  ]);
}

export namespace Product {
  /**
   * @generated from message web.public.Product.Metadata
   */
  export class Metadata extends Message<Product.Metadata> {
    /**
     * @generated from field: string key = 1;
     */
    key = "";

    /**
     * @generated from field: string value = 2;
     */
    value = "";

    constructor(data?: PartialMessage<Product.Metadata>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.Product.Metadata";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Product.Metadata {
      return new Product.Metadata().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Product.Metadata {
      return new Product.Metadata().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Product.Metadata {
      return new Product.Metadata().fromJsonString(jsonString, options);
    }

    static equals(a: Product.Metadata | PlainMessage<Product.Metadata> | undefined, b: Product.Metadata | PlainMessage<Product.Metadata> | undefined): boolean {
      return proto3.util.equals(Product.Metadata, a, b);
    }

    static _enums: {
    };
  }
}

export namespace Product {
  /**
   * @generated from message web.public.Product.Image
   */
  export class Image extends Message<Product.Image> {
    /**
     * @generated from field: string url = 1;
     */
    url = "";

    /**
     * @generated from field: uint32 width = 2;
     */
    width = 0;

    /**
     * @generated from field: uint32 height = 3;
     */
    height = 0;

    /**
     * @generated from field: web.public.Product.Image.Type type = 4;
     */
    type = Product.Image.Type.UNKNOWN;

    constructor(data?: PartialMessage<Product.Image>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.Product.Image";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "width", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 3, name: "height", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 4, name: "type", kind: "enum", T: proto3.getEnumType(Product.Image.Type) },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Product.Image {
      return new Product.Image().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Product.Image {
      return new Product.Image().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Product.Image {
      return new Product.Image().fromJsonString(jsonString, options);
    }

    static equals(a: Product.Image | PlainMessage<Product.Image> | undefined, b: Product.Image | PlainMessage<Product.Image> | undefined): boolean {
      return proto3.util.equals(Product.Image, a, b);
    }

    static _enums: {
      Type: typeof Product.Image.Type,
    };
  }
}

export namespace Product.Image {
  /**
   * @generated from enum web.public.Product.Image.Type
   */
  export enum Type {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: THUMBNAIL = 1;
     */
    THUMBNAIL = 1,

    /**
     * @generated from enum value: ICON = 2;
     */
    ICON = 2,

    /**
     * @generated from enum value: CARROUSEL_ITEM = 3;
     */
    CARROUSEL_ITEM = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(Product.Image.Type)
  proto3.util.setEnumType(Product.Image.Type, "web.public.Product.Image.Type", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "THUMBNAIL" },
    { no: 2, name: "ICON" },
    { no: 3, name: "CARROUSEL_ITEM" },
  ]);
}

/**
 * @generated from message web.public.ProductMedium
 */
export class ProductMedium extends Message<ProductMedium> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string subtitle = 4;
   */
  subtitle = "";

  /**
   * @generated from field: string description = 5;
   */
  description = "";

  /**
   * @generated from field: web.public.Image thumbnail = 6;
   */
  thumbnail?: Image$1;

  /**
   * @generated from field: repeated web.public.ProductMedium.Metadata metadata = 3;
   */
  metadata: ProductMedium.Metadata[] = [];

  constructor(data?: PartialMessage<ProductMedium>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ProductMedium";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "subtitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "thumbnail", kind: "message", T: Image$1 },
    { no: 3, name: "metadata", kind: "message", T: ProductMedium.Metadata, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProductMedium {
    return new ProductMedium().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProductMedium {
    return new ProductMedium().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProductMedium {
    return new ProductMedium().fromJsonString(jsonString, options);
  }

  static equals(a: ProductMedium | PlainMessage<ProductMedium> | undefined, b: ProductMedium | PlainMessage<ProductMedium> | undefined): boolean {
    return proto3.util.equals(ProductMedium, a, b);
  }

  static _enums: {
  };
}

export namespace ProductMedium {
  /**
   * @generated from message web.public.ProductMedium.Metadata
   */
  export class Metadata extends Message<ProductMedium.Metadata> {
    /**
     * @generated from field: string key = 1;
     */
    key = "";

    /**
     * @generated from field: string value = 2;
     */
    value = "";

    constructor(data?: PartialMessage<ProductMedium.Metadata>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.ProductMedium.Metadata";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProductMedium.Metadata {
      return new ProductMedium.Metadata().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProductMedium.Metadata {
      return new ProductMedium.Metadata().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProductMedium.Metadata {
      return new ProductMedium.Metadata().fromJsonString(jsonString, options);
    }

    static equals(a: ProductMedium.Metadata | PlainMessage<ProductMedium.Metadata> | undefined, b: ProductMedium.Metadata | PlainMessage<ProductMedium.Metadata> | undefined): boolean {
      return proto3.util.equals(ProductMedium.Metadata, a, b);
    }

    static _enums: {
    };
  }
}

/**
 * @generated from message web.public.MediaGroup
 */
export class MediaGroup extends Message<MediaGroup> {
  /**
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: repeated web.public.ProductMedium media = 3;
   */
  media: ProductMedium[] = [];

  constructor(data?: PartialMessage<MediaGroup>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.MediaGroup";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "media", kind: "message", T: ProductMedium, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MediaGroup {
    return new MediaGroup().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MediaGroup {
    return new MediaGroup().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MediaGroup {
    return new MediaGroup().fromJsonString(jsonString, options);
  }

  static equals(a: MediaGroup | PlainMessage<MediaGroup> | undefined, b: MediaGroup | PlainMessage<MediaGroup> | undefined): boolean {
    return proto3.util.equals(MediaGroup, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.OrderItem
 */
export class OrderItem extends Message<OrderItem> {
  /**
   * @generated from field: web.public.Product product = 1;
   */
  product?: Product;

  /**
   * @generated from field: uint32 quantity = 2;
   */
  quantity = 0;

  /**
   * @generated from field: uint32 price_cents = 3;
   */
  priceCents = 0;

  /**
   * soon to be deprecated
   *
   * @generated from field: string download_url = 4;
   */
  downloadUrl = "";

  /**
   * @generated from field: web.public.Review review = 5;
   */
  review?: Review;

  /**
   * soon to be deprecated.
   *
   * @generated from field: repeated web.public.ProductMedium media = 6;
   */
  media: ProductMedium[] = [];

  /**
   * @generated from field: repeated web.public.MediaGroup media_groups = 7;
   */
  mediaGroups: MediaGroup[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp lease_expires_at = 8;
   */
  leaseExpiresAt?: Timestamp;

  constructor(data?: PartialMessage<OrderItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.OrderItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "product", kind: "message", T: Product },
    { no: 2, name: "quantity", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "price_cents", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "download_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "review", kind: "message", T: Review },
    { no: 6, name: "media", kind: "message", T: ProductMedium, repeated: true },
    { no: 7, name: "media_groups", kind: "message", T: MediaGroup, repeated: true },
    { no: 8, name: "lease_expires_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderItem {
    return new OrderItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderItem {
    return new OrderItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderItem {
    return new OrderItem().fromJsonString(jsonString, options);
  }

  static equals(a: OrderItem | PlainMessage<OrderItem> | undefined, b: OrderItem | PlainMessage<OrderItem> | undefined): boolean {
    return proto3.util.equals(OrderItem, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.Order
 */
export class Order extends Message<Order> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  /**
   * @generated from field: web.public.Order.Status status = 2;
   */
  status = Order.Status.UNKNOWN;

  /**
   * @generated from field: google.protobuf.Timestamp purchased_at = 3;
   */
  purchasedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp refunded_at = 4;
   */
  refundedAt?: Timestamp;

  /**
   * @generated from field: int32 total_price_cents = 5;
   */
  totalPriceCents = 0;

  /**
   * @generated from field: repeated web.public.OrderItem order_items = 6;
   */
  orderItems: OrderItem[] = [];

  /**
   * @generated from field: bool hide_order = 7;
   */
  hideOrder = false;

  constructor(data?: PartialMessage<Order>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.Order";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(Order.Status) },
    { no: 3, name: "purchased_at", kind: "message", T: Timestamp },
    { no: 4, name: "refunded_at", kind: "message", T: Timestamp },
    { no: 5, name: "total_price_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "order_items", kind: "message", T: OrderItem, repeated: true },
    { no: 7, name: "hide_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Order {
    return new Order().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Order {
    return new Order().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Order {
    return new Order().fromJsonString(jsonString, options);
  }

  static equals(a: Order | PlainMessage<Order> | undefined, b: Order | PlainMessage<Order> | undefined): boolean {
    return proto3.util.equals(Order, a, b);
  }

  static _enums: {
    Status: typeof Order.Status,
  };
}

export namespace Order {
  /**
   * @generated from enum web.public.Order.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: INCOMPLETE = 1;
     */
    INCOMPLETE = 1,

    /**
     * @generated from enum value: PAID = 2;
     */
    PAID = 2,

    /**
     * @generated from enum value: REFUNDED = 3;
     */
    REFUNDED = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(Order.Status)
  proto3.util.setEnumType(Order.Status, "web.public.Order.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "INCOMPLETE" },
    { no: 2, name: "PAID" },
    { no: 3, name: "REFUNDED" },
  ]);
}

/**
 * @generated from message web.public.ShoppingIncentives
 */
export class ShoppingIncentives extends Message<ShoppingIncentives> {
  /**
   * @generated from field: bool is_new = 1;
   */
  isNew = false;

  /**
   * @generated from oneof web.public.ShoppingIncentives.offer
   */
  offer: {
    /**
     * @generated from field: web.public.ShoppingIncentives.CreditLineIncrease credit_line_increase = 2;
     */
    value: ShoppingIncentives.CreditLineIncrease;
    case: "creditLineIncrease";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ShoppingIncentives>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ShoppingIncentives";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_new", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "credit_line_increase", kind: "message", T: ShoppingIncentives.CreditLineIncrease, oneof: "offer" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ShoppingIncentives {
    return new ShoppingIncentives().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ShoppingIncentives {
    return new ShoppingIncentives().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ShoppingIncentives {
    return new ShoppingIncentives().fromJsonString(jsonString, options);
  }

  static equals(a: ShoppingIncentives | PlainMessage<ShoppingIncentives> | undefined, b: ShoppingIncentives | PlainMessage<ShoppingIncentives> | undefined): boolean {
    return proto3.util.equals(ShoppingIncentives, a, b);
  }

  static _enums: {
  };
}

export namespace ShoppingIncentives {
  /**
   * @generated from message web.public.ShoppingIncentives.CreditLineIncrease
   */
  export class CreditLineIncrease extends Message<ShoppingIncentives.CreditLineIncrease> {
    /**
     * @generated from field: int32 credit_limit_cents = 1;
     */
    creditLimitCents = 0;

    /**
     * @generated from field: int32 new_credit_limit_cents = 2;
     */
    newCreditLimitCents = 0;

    constructor(data?: PartialMessage<ShoppingIncentives.CreditLineIncrease>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.ShoppingIncentives.CreditLineIncrease";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "credit_limit_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
      { no: 2, name: "new_credit_limit_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ShoppingIncentives.CreditLineIncrease {
      return new ShoppingIncentives.CreditLineIncrease().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ShoppingIncentives.CreditLineIncrease {
      return new ShoppingIncentives.CreditLineIncrease().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ShoppingIncentives.CreditLineIncrease {
      return new ShoppingIncentives.CreditLineIncrease().fromJsonString(jsonString, options);
    }

    static equals(a: ShoppingIncentives.CreditLineIncrease | PlainMessage<ShoppingIncentives.CreditLineIncrease> | undefined, b: ShoppingIncentives.CreditLineIncrease | PlainMessage<ShoppingIncentives.CreditLineIncrease> | undefined): boolean {
      return proto3.util.equals(ShoppingIncentives.CreditLineIncrease, a, b);
    }

    static _enums: {
    };
  }
}

/**
 * @generated from message web.public.ListCatalogRequest
 */
export class ListCatalogRequest extends Message<ListCatalogRequest> {
  /**
   * @generated from field: web.public.ListCatalogRequest.ListCatalogueContext context = 1;
   */
  context = ListCatalogRequest.ListCatalogueContext.DEFAULT;

  constructor(data?: PartialMessage<ListCatalogRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ListCatalogRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "context", kind: "enum", T: proto3.getEnumType(ListCatalogRequest.ListCatalogueContext) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCatalogRequest {
    return new ListCatalogRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCatalogRequest {
    return new ListCatalogRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCatalogRequest {
    return new ListCatalogRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCatalogRequest | PlainMessage<ListCatalogRequest> | undefined, b: ListCatalogRequest | PlainMessage<ListCatalogRequest> | undefined): boolean {
    return proto3.util.equals(ListCatalogRequest, a, b);
  }

  static _enums: {
    ListCatalogueContext: typeof ListCatalogRequest.ListCatalogueContext,
  };
}

export namespace ListCatalogRequest {
  /**
   * @generated from enum web.public.ListCatalogRequest.ListCatalogueContext
   */
  export enum ListCatalogueContext {
    /**
     * @generated from enum value: DEFAULT = 0;
     */
    DEFAULT = 0,

    /**
     * @generated from enum value: KIKOFF_STORE = 3;
     */
    KIKOFF_STORE = 3,

    /**
     * @generated from enum value: SELECT_PLAN = 4;
     */
    SELECT_PLAN = 4,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ListCatalogRequest.ListCatalogueContext)
  proto3.util.setEnumType(ListCatalogRequest.ListCatalogueContext, "web.public.ListCatalogRequest.ListCatalogueContext", [
    { no: 0, name: "DEFAULT" },
    { no: 3, name: "KIKOFF_STORE" },
    { no: 4, name: "SELECT_PLAN" },
  ]);
}

/**
 * @generated from message web.public.ListCatalogResponse
 */
export class ListCatalogResponse extends Message<ListCatalogResponse> {
  /**
   * @generated from field: web.public.ListCatalogResponse.Status status = 1;
   */
  status = ListCatalogResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated web.public.Product products = 3;
   */
  products: Product[] = [];

  /**
   * @generated from field: repeated web.public.ShoppingIncentives shopping_incentives = 4;
   */
  shoppingIncentives: ShoppingIncentives[] = [];

  /**
   * @generated from field: string header_text = 5;
   */
  headerText = "";

  constructor(data?: PartialMessage<ListCatalogResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ListCatalogResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ListCatalogResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "products", kind: "message", T: Product, repeated: true },
    { no: 4, name: "shopping_incentives", kind: "message", T: ShoppingIncentives, repeated: true },
    { no: 5, name: "header_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCatalogResponse {
    return new ListCatalogResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCatalogResponse {
    return new ListCatalogResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCatalogResponse {
    return new ListCatalogResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCatalogResponse | PlainMessage<ListCatalogResponse> | undefined, b: ListCatalogResponse | PlainMessage<ListCatalogResponse> | undefined): boolean {
    return proto3.util.equals(ListCatalogResponse, a, b);
  }

  static _enums: {
    Status: typeof ListCatalogResponse.Status,
  };
}

export namespace ListCatalogResponse {
  /**
   * @generated from enum web.public.ListCatalogResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ListCatalogResponse.Status)
  proto3.util.setEnumType(ListCatalogResponse.Status, "web.public.ListCatalogResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.ListOrdersRequest
 */
export class ListOrdersRequest extends Message<ListOrdersRequest> {
  constructor(data?: PartialMessage<ListOrdersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ListOrdersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListOrdersRequest {
    return new ListOrdersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListOrdersRequest {
    return new ListOrdersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListOrdersRequest {
    return new ListOrdersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListOrdersRequest | PlainMessage<ListOrdersRequest> | undefined, b: ListOrdersRequest | PlainMessage<ListOrdersRequest> | undefined): boolean {
    return proto3.util.equals(ListOrdersRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.ListOrdersResponse
 */
export class ListOrdersResponse extends Message<ListOrdersResponse> {
  /**
   * @generated from field: web.public.ListOrdersResponse.Status status = 1;
   */
  status = ListOrdersResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated web.public.Order orders = 3;
   */
  orders: Order[] = [];

  /**
   * @generated from field: repeated web.public.UserSubscription user_subscriptions = 4;
   */
  userSubscriptions: UserSubscription[] = [];

  /**
   * @generated from field: repeated web.public.UserSubscriptionInvoice user_subscription_invoices = 5;
   */
  userSubscriptionInvoices: UserSubscriptionInvoice[] = [];

  /**
   * @generated from field: web.public.Product active_subscription_product = 6;
   */
  activeSubscriptionProduct?: Product;

  constructor(data?: PartialMessage<ListOrdersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ListOrdersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ListOrdersResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "orders", kind: "message", T: Order, repeated: true },
    { no: 4, name: "user_subscriptions", kind: "message", T: UserSubscription, repeated: true },
    { no: 5, name: "user_subscription_invoices", kind: "message", T: UserSubscriptionInvoice, repeated: true },
    { no: 6, name: "active_subscription_product", kind: "message", T: Product },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListOrdersResponse {
    return new ListOrdersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListOrdersResponse {
    return new ListOrdersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListOrdersResponse {
    return new ListOrdersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListOrdersResponse | PlainMessage<ListOrdersResponse> | undefined, b: ListOrdersResponse | PlainMessage<ListOrdersResponse> | undefined): boolean {
    return proto3.util.equals(ListOrdersResponse, a, b);
  }

  static _enums: {
    Status: typeof ListOrdersResponse.Status,
  };
}

export namespace ListOrdersResponse {
  /**
   * @generated from enum web.public.ListOrdersResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ListOrdersResponse.Status)
  proto3.util.setEnumType(ListOrdersResponse.Status, "web.public.ListOrdersResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.CheckoutRequest
 */
export class CheckoutRequest extends Message<CheckoutRequest> {
  /**
   * @generated from field: string product_token = 1;
   */
  productToken = "";

  /**
   * @generated from field: string identity_verification_token = 2;
   */
  identityVerificationToken = "";

  /**
   * @generated from field: web.public.AutoRenew auto_renew = 4;
   */
  autoRenew?: AutoRenew;

  /**
   * @generated from field: google.protobuf.Timestamp first_payment_date = 5;
   */
  firstPaymentDate?: Timestamp;

  /**
   * @generated from field: web.public.AutoPay.Settings auto_pay = 6;
   */
  autoPay?: AutoPay.Settings;

  /**
   * @generated from field: bool pay_upfront = 7;
   */
  payUpfront = false;

  /**
   * @generated from field: bool is_renewal = 8;
   */
  isRenewal = false;

  constructor(data?: PartialMessage<CheckoutRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CheckoutRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "product_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "identity_verification_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "auto_renew", kind: "message", T: AutoRenew },
    { no: 5, name: "first_payment_date", kind: "message", T: Timestamp },
    { no: 6, name: "auto_pay", kind: "message", T: AutoPay.Settings },
    { no: 7, name: "pay_upfront", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "is_renewal", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckoutRequest {
    return new CheckoutRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckoutRequest {
    return new CheckoutRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckoutRequest {
    return new CheckoutRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CheckoutRequest | PlainMessage<CheckoutRequest> | undefined, b: CheckoutRequest | PlainMessage<CheckoutRequest> | undefined): boolean {
    return proto3.util.equals(CheckoutRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.CheckoutResponse
 */
export class CheckoutResponse extends Message<CheckoutResponse> {
  /**
   * @generated from field: web.public.CheckoutResponse.Status status = 1;
   */
  status = CheckoutResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.PaymentSchedule payment_schedule = 3;
   */
  paymentSchedule?: PaymentSchedule;

  /**
   * @generated from field: web.public.Order order = 4;
   */
  order?: Order;

  constructor(data?: PartialMessage<CheckoutResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CheckoutResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(CheckoutResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "payment_schedule", kind: "message", T: PaymentSchedule },
    { no: 4, name: "order", kind: "message", T: Order },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckoutResponse {
    return new CheckoutResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckoutResponse {
    return new CheckoutResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckoutResponse {
    return new CheckoutResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CheckoutResponse | PlainMessage<CheckoutResponse> | undefined, b: CheckoutResponse | PlainMessage<CheckoutResponse> | undefined): boolean {
    return proto3.util.equals(CheckoutResponse, a, b);
  }

  static _enums: {
    Status: typeof CheckoutResponse.Status,
  };
}

export namespace CheckoutResponse {
  /**
   * @generated from enum web.public.CheckoutResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(CheckoutResponse.Status)
  proto3.util.setEnumType(CheckoutResponse.Status, "web.public.CheckoutResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.CheckoutPreviewRequest
 */
export class CheckoutPreviewRequest extends Message<CheckoutPreviewRequest> {
  /**
   * @generated from field: string product_token = 1;
   */
  productToken = "";

  /**
   * @generated from field: bool is_renewal = 2;
   */
  isRenewal = false;

  constructor(data?: PartialMessage<CheckoutPreviewRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CheckoutPreviewRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "product_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_renewal", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckoutPreviewRequest {
    return new CheckoutPreviewRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckoutPreviewRequest {
    return new CheckoutPreviewRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckoutPreviewRequest {
    return new CheckoutPreviewRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CheckoutPreviewRequest | PlainMessage<CheckoutPreviewRequest> | undefined, b: CheckoutPreviewRequest | PlainMessage<CheckoutPreviewRequest> | undefined): boolean {
    return proto3.util.equals(CheckoutPreviewRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.CheckoutPreviewResponse
 */
export class CheckoutPreviewResponse extends Message<CheckoutPreviewResponse> {
  /**
   * @generated from field: web.public.CheckoutPreviewResponse.Status status = 1;
   */
  status = CheckoutPreviewResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: uint32 credit_limit_cents = 3;
   */
  creditLimitCents = 0;

  /**
   * @generated from field: int32 credit_balance_cents = 4;
   */
  creditBalanceCents = 0;

  /**
   * @generated from field: int32 new_credit_balance_cents = 5;
   */
  newCreditBalanceCents = 0;

  /**
   * @generated from field: int32 new_credit_limit_cents = 10;
   */
  newCreditLimitCents = 0;

  /**
   * @generated from field: web.public.PaymentSchedule payment_schedule = 6;
   */
  paymentSchedule?: PaymentSchedule;

  /**
   * @generated from field: web.public.Order order = 7;
   */
  order?: Order;

  /**
   * @generated from field: bool credit_agreement_signed = 8;
   */
  creditAgreementSigned = false;

  /**
   * @generated from field: repeated string warnings = 9;
   */
  warnings: string[] = [];

  /**
   * @generated from field: web.public.AutoRenew auto_renew = 12;
   */
  autoRenew?: AutoRenew;

  /**
   * @generated from field: web.public.CreditLineAgreement credit_line_agreement = 13;
   */
  creditLineAgreement?: CreditLineAgreement;

  /**
   * @generated from field: repeated web.public.PaymentOption payment_options = 14;
   */
  paymentOptions: PaymentOption[] = [];

  constructor(data?: PartialMessage<CheckoutPreviewResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CheckoutPreviewResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(CheckoutPreviewResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "credit_limit_cents", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "credit_balance_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "new_credit_balance_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "new_credit_limit_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "payment_schedule", kind: "message", T: PaymentSchedule },
    { no: 7, name: "order", kind: "message", T: Order },
    { no: 8, name: "credit_agreement_signed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "warnings", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "auto_renew", kind: "message", T: AutoRenew },
    { no: 13, name: "credit_line_agreement", kind: "message", T: CreditLineAgreement },
    { no: 14, name: "payment_options", kind: "message", T: PaymentOption, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckoutPreviewResponse {
    return new CheckoutPreviewResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckoutPreviewResponse {
    return new CheckoutPreviewResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckoutPreviewResponse {
    return new CheckoutPreviewResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CheckoutPreviewResponse | PlainMessage<CheckoutPreviewResponse> | undefined, b: CheckoutPreviewResponse | PlainMessage<CheckoutPreviewResponse> | undefined): boolean {
    return proto3.util.equals(CheckoutPreviewResponse, a, b);
  }

  static _enums: {
    Status: typeof CheckoutPreviewResponse.Status,
  };
}

export namespace CheckoutPreviewResponse {
  /**
   * @generated from enum web.public.CheckoutPreviewResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(CheckoutPreviewResponse.Status)
  proto3.util.setEnumType(CheckoutPreviewResponse.Status, "web.public.CheckoutPreviewResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.RateProductRequest
 */
export class RateProductRequest extends Message<RateProductRequest> {
  /**
   * @generated from field: string product_token = 1;
   */
  productToken = "";

  /**
   * @generated from field: web.public.Review review = 2;
   */
  review?: Review;

  constructor(data?: PartialMessage<RateProductRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.RateProductRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "product_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "review", kind: "message", T: Review },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RateProductRequest {
    return new RateProductRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RateProductRequest {
    return new RateProductRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RateProductRequest {
    return new RateProductRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RateProductRequest | PlainMessage<RateProductRequest> | undefined, b: RateProductRequest | PlainMessage<RateProductRequest> | undefined): boolean {
    return proto3.util.equals(RateProductRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.RateProductResponse
 */
export class RateProductResponse extends Message<RateProductResponse> {
  /**
   * @generated from field: web.public.RateProductResponse.Status status = 1;
   */
  status = RateProductResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  constructor(data?: PartialMessage<RateProductResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.RateProductResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(RateProductResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RateProductResponse {
    return new RateProductResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RateProductResponse {
    return new RateProductResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RateProductResponse {
    return new RateProductResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RateProductResponse | PlainMessage<RateProductResponse> | undefined, b: RateProductResponse | PlainMessage<RateProductResponse> | undefined): boolean {
    return proto3.util.equals(RateProductResponse, a, b);
  }

  static _enums: {
    Status: typeof RateProductResponse.Status,
  };
}

export namespace RateProductResponse {
  /**
   * @generated from enum web.public.RateProductResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(RateProductResponse.Status)
  proto3.util.setEnumType(RateProductResponse.Status, "web.public.RateProductResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.PreviewPremiumUpgradeRequest
 * @deprecated
 */
export class PreviewPremiumUpgradeRequest extends Message<PreviewPremiumUpgradeRequest> {
  /**
   * @generated from field: web.public.PreviewPremiumUpgradeRequest.Context context = 1 [deprecated = true];
   * @deprecated
   */
  context = PreviewPremiumUpgradeRequest.Context.DEFAULT;

  constructor(data?: PartialMessage<PreviewPremiumUpgradeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.PreviewPremiumUpgradeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "context", kind: "enum", T: proto3.getEnumType(PreviewPremiumUpgradeRequest.Context) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PreviewPremiumUpgradeRequest {
    return new PreviewPremiumUpgradeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PreviewPremiumUpgradeRequest {
    return new PreviewPremiumUpgradeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PreviewPremiumUpgradeRequest {
    return new PreviewPremiumUpgradeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PreviewPremiumUpgradeRequest | PlainMessage<PreviewPremiumUpgradeRequest> | undefined, b: PreviewPremiumUpgradeRequest | PlainMessage<PreviewPremiumUpgradeRequest> | undefined): boolean {
    return proto3.util.equals(PreviewPremiumUpgradeRequest, a, b);
  }

  static _enums: {
    Context: typeof PreviewPremiumUpgradeRequest.Context,
  };
}

export namespace PreviewPremiumUpgradeRequest {
  /**
   * @generated from enum web.public.PreviewPremiumUpgradeRequest.Context
   */
  export enum Context {
    /**
     * @generated from enum value: DEFAULT = 0;
     */
    DEFAULT = 0,

    /**
     * @generated from enum value: DISPUTES = 1;
     */
    DISPUTES = 1,
  }
  // Retrieve enum metadata with: proto3.getEnumType(PreviewPremiumUpgradeRequest.Context)
  proto3.util.setEnumType(PreviewPremiumUpgradeRequest.Context, "web.public.PreviewPremiumUpgradeRequest.Context", [
    { no: 0, name: "DEFAULT" },
    { no: 1, name: "DISPUTES" },
  ]);
}

/**
 * @generated from message web.public.PreviewPremiumUpgradeResponse
 */
export class PreviewPremiumUpgradeResponse extends Message<PreviewPremiumUpgradeResponse> {
  /**
   * @generated from field: web.public.PreviewPremiumUpgradeResponse.Status status = 1;
   */
  status = PreviewPremiumUpgradeResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: bool allow_upgrade = 3;
   */
  allowUpgrade = false;

  /**
   * @generated from field: web.public.Product product = 4;
   */
  product?: Product;

  /**
   * @generated from field: web.public.PaymentSchedule payment_schedule = 5;
   */
  paymentSchedule?: PaymentSchedule;

  constructor(data?: PartialMessage<PreviewPremiumUpgradeResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.PreviewPremiumUpgradeResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(PreviewPremiumUpgradeResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "allow_upgrade", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "product", kind: "message", T: Product },
    { no: 5, name: "payment_schedule", kind: "message", T: PaymentSchedule },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PreviewPremiumUpgradeResponse {
    return new PreviewPremiumUpgradeResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PreviewPremiumUpgradeResponse {
    return new PreviewPremiumUpgradeResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PreviewPremiumUpgradeResponse {
    return new PreviewPremiumUpgradeResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PreviewPremiumUpgradeResponse | PlainMessage<PreviewPremiumUpgradeResponse> | undefined, b: PreviewPremiumUpgradeResponse | PlainMessage<PreviewPremiumUpgradeResponse> | undefined): boolean {
    return proto3.util.equals(PreviewPremiumUpgradeResponse, a, b);
  }

  static _enums: {
    Status: typeof PreviewPremiumUpgradeResponse.Status,
  };
}

export namespace PreviewPremiumUpgradeResponse {
  /**
   * @generated from enum web.public.PreviewPremiumUpgradeResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(PreviewPremiumUpgradeResponse.Status)
  proto3.util.setEnumType(PreviewPremiumUpgradeResponse.Status, "web.public.PreviewPremiumUpgradeResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.UpgradeToPremiumRequest
 */
export class UpgradeToPremiumRequest extends Message<UpgradeToPremiumRequest> {
  /**
   * @generated from field: string source = 1;
   */
  source = "";

  constructor(data?: PartialMessage<UpgradeToPremiumRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpgradeToPremiumRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpgradeToPremiumRequest {
    return new UpgradeToPremiumRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpgradeToPremiumRequest {
    return new UpgradeToPremiumRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpgradeToPremiumRequest {
    return new UpgradeToPremiumRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpgradeToPremiumRequest | PlainMessage<UpgradeToPremiumRequest> | undefined, b: UpgradeToPremiumRequest | PlainMessage<UpgradeToPremiumRequest> | undefined): boolean {
    return proto3.util.equals(UpgradeToPremiumRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.UpgradeToPremiumResponse
 */
export class UpgradeToPremiumResponse extends Message<UpgradeToPremiumResponse> {
  /**
   * @generated from field: web.public.UpgradeToPremiumResponse.Status status = 1;
   */
  status = UpgradeToPremiumResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  constructor(data?: PartialMessage<UpgradeToPremiumResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpgradeToPremiumResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(UpgradeToPremiumResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpgradeToPremiumResponse {
    return new UpgradeToPremiumResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpgradeToPremiumResponse {
    return new UpgradeToPremiumResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpgradeToPremiumResponse {
    return new UpgradeToPremiumResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpgradeToPremiumResponse | PlainMessage<UpgradeToPremiumResponse> | undefined, b: UpgradeToPremiumResponse | PlainMessage<UpgradeToPremiumResponse> | undefined): boolean {
    return proto3.util.equals(UpgradeToPremiumResponse, a, b);
  }

  static _enums: {
    Status: typeof UpgradeToPremiumResponse.Status,
  };
}

export namespace UpgradeToPremiumResponse {
  /**
   * @generated from enum web.public.UpgradeToPremiumResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(UpgradeToPremiumResponse.Status)
  proto3.util.setEnumType(UpgradeToPremiumResponse.Status, "web.public.UpgradeToPremiumResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.ListSubscriptionsRequest
 */
export class ListSubscriptionsRequest extends Message<ListSubscriptionsRequest> {
  constructor(data?: PartialMessage<ListSubscriptionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ListSubscriptionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSubscriptionsRequest {
    return new ListSubscriptionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSubscriptionsRequest {
    return new ListSubscriptionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSubscriptionsRequest {
    return new ListSubscriptionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSubscriptionsRequest | PlainMessage<ListSubscriptionsRequest> | undefined, b: ListSubscriptionsRequest | PlainMessage<ListSubscriptionsRequest> | undefined): boolean {
    return proto3.util.equals(ListSubscriptionsRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.ListSubscriptionsResponse
 */
export class ListSubscriptionsResponse extends Message<ListSubscriptionsResponse> {
  /**
   * @generated from field: web.public.ListSubscriptionsResponse.Status status = 1;
   */
  status = ListSubscriptionsResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated web.public.Product products = 3;
   */
  products: Product[] = [];

  constructor(data?: PartialMessage<ListSubscriptionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ListSubscriptionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ListSubscriptionsResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "products", kind: "message", T: Product, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSubscriptionsResponse {
    return new ListSubscriptionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSubscriptionsResponse {
    return new ListSubscriptionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSubscriptionsResponse {
    return new ListSubscriptionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSubscriptionsResponse | PlainMessage<ListSubscriptionsResponse> | undefined, b: ListSubscriptionsResponse | PlainMessage<ListSubscriptionsResponse> | undefined): boolean {
    return proto3.util.equals(ListSubscriptionsResponse, a, b);
  }

  static _enums: {
    Status: typeof ListSubscriptionsResponse.Status,
  };
}

export namespace ListSubscriptionsResponse {
  /**
   * @generated from enum web.public.ListSubscriptionsResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ListSubscriptionsResponse.Status)
  proto3.util.setEnumType(ListSubscriptionsResponse.Status, "web.public.ListSubscriptionsResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.FetchCurrentSubscriptionProductResponse
 */
export class FetchCurrentSubscriptionProductResponse extends Message<FetchCurrentSubscriptionProductResponse> {
  /**
   * @generated from field: web.public.FetchCurrentSubscriptionProductResponse.Status status = 1;
   */
  status = FetchCurrentSubscriptionProductResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.Product current_subscription_product = 3;
   */
  currentSubscriptionProduct?: Product;

  constructor(data?: PartialMessage<FetchCurrentSubscriptionProductResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.FetchCurrentSubscriptionProductResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(FetchCurrentSubscriptionProductResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "current_subscription_product", kind: "message", T: Product },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchCurrentSubscriptionProductResponse {
    return new FetchCurrentSubscriptionProductResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchCurrentSubscriptionProductResponse {
    return new FetchCurrentSubscriptionProductResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchCurrentSubscriptionProductResponse {
    return new FetchCurrentSubscriptionProductResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FetchCurrentSubscriptionProductResponse | PlainMessage<FetchCurrentSubscriptionProductResponse> | undefined, b: FetchCurrentSubscriptionProductResponse | PlainMessage<FetchCurrentSubscriptionProductResponse> | undefined): boolean {
    return proto3.util.equals(FetchCurrentSubscriptionProductResponse, a, b);
  }

  static _enums: {
    Status: typeof FetchCurrentSubscriptionProductResponse.Status,
  };
}

export namespace FetchCurrentSubscriptionProductResponse {
  /**
   * @generated from enum web.public.FetchCurrentSubscriptionProductResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(FetchCurrentSubscriptionProductResponse.Status)
  proto3.util.setEnumType(FetchCurrentSubscriptionProductResponse.Status, "web.public.FetchCurrentSubscriptionProductResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

